import { BundleAlertDefinitionsState } from 'src/models/state/bundleAlertDefinitionsState';
import { AppState } from '../models/state/appState';

/**
 * Selects the bundle alert definitions state.
 * @param state The aplication state.
 */
export function selectBundleAlertDefinitions(state: AppState): BundleAlertDefinitionsState {
  return state.bundleAlertDefinitions;
}
